import { useMyLeadsCRUDActions } from '@mm/state/actions/MyLeadsCRUDActions';
import {
  MyLeadsFilterTypes,
  MyLeadsSearchQuery,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { LandingPagesRemoteSearch } from '../../../../../../common/components/LandingPagesRemoteSearch/LandingPagesRemoteSearch';
import { convertToUpperSnakeCase } from '../../GetLeads/LeadsSearch/LeadsSearchFiltersMenu/helpers';
import { useFilterParams } from '../MyLeadsFiltersPanel/use-filter-params';
import styles from './FilterByLandingPage.module.css';

type Props = {
  attributeKey: string;
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
};

export const FilterByLandingPage = ({
  attributeKey,
  filterParams,
  setFilterParams,
}: Props) => {
  const botId = useSelector(activeChatbotIdSelector);
  const { retrieveLandingPages } = useMyLeadsCRUDActions();
  const { getUpdatedFilterParams, shouldDisableFilters, isFilterParamExist } =
    useFilterParams({
      filterParams,
    });
  const key = convertToUpperSnakeCase(SubsectionKeys.landingPageUrl);

  const fetchLandings = async (query: string) => {
    if (query?.length >= 3) {
      const res = await retrieveLandingPages(botId, query);
      return res as string[];
    }
    return [];
  };

  const onUpdateFilterParams = (value: string) => {
    const isExisting = isFilterParamExist({
      key: attributeKey,
      value,
      type: MyLeadsFilterTypes.variables,
    });

    const updatedQuery = getUpdatedFilterParams({
      key: attributeKey,
      value,
      isExisting,
      type: MyLeadsFilterTypes.variables,
    });
    setFilterParams(updatedQuery);
  };

  return (
    <LandingPagesRemoteSearch
      className={styles.remoteSearchContainer}
      title="Landing Page URL"
      placeholder="Exact URL or contains (min 3 characters)"
      remoteLandings={filterParams?.query?.variables?.[key]}
      onFetch={fetchLandings}
      onSelect={onUpdateFilterParams}
      onDelete={onUpdateFilterParams}
      searchDisabled={shouldDisableFilters}
    />
  );
};
